if (!customElements.get('cart-upgrade-button')) {
  customElements.define(
    'cart-upgrade-button',
    class CartUpgradeButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.cart-item__upgrade-button');
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick(evt) {
        evt.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const currentKey = this.dataset.currentKey;
        const targetVariantId = this.dataset.targetVariantId;
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        fetch(`${routes.cart_change_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: currentKey, quantity: 0 }),
        })
          .then((response) => response.json())
          .then(() => {
            const body = {
              items: [
                {
                  id: parseInt(targetVariantId, 10),
                  quantity: 1,
                  properties: { _upgraded: 'true' },
                },
              ],
            };
            if (cart) {
              body.sections = cart.getSectionsToRender().map((section) => section.id);
              body.sections_url = window.location.pathname;
            }
            return fetch(`${routes.cart_add_url}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            });
          })
          .then((response) => response.json())
          .then((response) => {
            if (cart) {
              cart.renderContents(response);
            } else {
              window.location = routes.cart_url;
            }
          })
          .catch((e) => {
            console.error(e);
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
